// Module-level memory for the Receivers page so its UI state survives being
// unmounted: App swaps pages by `currentPage`, so "View Live" → map →
// "← Back to Receivers" remounts the page. Without this it came back on the
// default scope with filters, sort and scroll reset.
//
// In-memory on purpose (not localStorage): the state is only meaningful
// within one session, and the cached all-receivers list must not outlive it.

const state = {
  scope: 'mine',            // 'mine' | 'all' (admin only)
  statusFilter: '',         // '' | 'online' | 'offline'
  ownerFilter: '',          // '' = every owner (all scope only)
  groupByOwner: false,      // all scope only
  sort: { key: 'receiverName', dir: 'asc' },
  scrollTop: 0,             // list container scroll offset
  allReceivers: null,       // last getAllReceivers rows, so a remount renders instantly
  allLoadedAt: 0,
};

export function getReceiversViewState() {
  return state;
}

export function updateReceiversViewState(patch) {
  Object.assign(state, patch);
}

/** Test/debug helper — resets to defaults. */
export function resetReceiversViewState() {
  Object.assign(state, {
    scope: 'mine', statusFilter: '', ownerFilter: '', groupByOwner: false,
    sort: { key: 'receiverName', dir: 'asc' }, scrollTop: 0,
    allReceivers: null, allLoadedAt: 0,
  });
}
